import React from 'react'
import { Box } from '@mui/material'
import MezzoForm from '../../structure/Cantine/MezzoForm'


export const MezziSlider = ({cantine, setCantine}) => {

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Mezzi</h2>
            </Box>
            <MezzoForm cantine={cantine} setCantine={setCantine} />
        </Box>
    )
}
